import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { CompanyUser } from 'src/app/models/company-user.model';
import { UserService } from 'src/app/services/user.service';
import { UserManagementContext } from '../user-list/user-list.component';

@Component({
    selector: 'app-user-delete-dialog',
    templateUrl: './user-delete-dialog.component.html',
    styleUrls: ['./user-delete-dialog.component.scss'],
    standalone: false
})
export class UserDeleteDialogComponent implements OnInit {

  @Input() user: CompanyUser;
  @Input() companyId: number;
  @Input() context: UserManagementContext;

  public loading = false;

  constructor(
    protected dialogRef: NbDialogRef<UserDeleteDialogComponent>,
    protected userService: UserService
  ) { }

  ngOnInit(): void { }

  public deleteAction(): void {
    if (!this.user || !this.companyId) return;

    this.loading = true;
    this.userService.deleteCompanyUser(this.companyId, this.user.id).subscribe(
      done => {
        this.loading = false;
        this.dialogRef.close({ deleted: true });
      },
      error => {
        this.loading = false;
      }
    );
  }

  public closeAction(): void {
    this.dialogRef.close({ deleted: false });
  }
}
